import React from 'react';
import { useForm } from 'react-hook-form';

const ContactForm = () => {
  const { 
    register, 
    handleSubmit, 
    formState: { errors, isSubmitting, isSubmitSuccessful },
    reset
  } = useForm();

  const onSubmit = async (data) => {
    // Simulação de envio - em produção, conectar com API real
    console.log(data);
    
    // Simular delay de envio
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Resetar formulário após envio
    reset();
  };

  return (
    <section id="contato" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Contate-nos para mais informações</h2>
          <div className="w-20 h-1 bg-focoseg-green mx-auto"></div>
        </div>
        
        <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-lg p-8">
          {isSubmitSuccessful ? (
            <div className="text-center py-8">
              <div className="text-5xl text-green-500 mb-4">✓</div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Mensagem Enviada!</h3>
              <p className="text-gray-600 mb-6">Agradecemos seu contato. Retornaremos em breve.</p>
              <button
                onClick={() => reset()}
                className="bg-focoseg-green hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-lg transition duration-300"
              >
                Enviar nova mensagem
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Nome</label>
                  <input
                    type="text"
                    id="name"
                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focoseg-green ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
                    placeholder="Seu nome"
                    {...register('name', { required: 'Nome é obrigatório' })}
                  />
                  {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>}
                </div>
                
                <div>
                  <label htmlFor="company" className="block text-gray-700 font-medium mb-2">Empresa</label>
                  <input
                    type="text"
                    id="company"
                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focoseg-green ${errors.company ? 'border-red-500' : 'border-gray-300'}`}
                    placeholder="Nome da empresa"
                    {...register('company', { required: 'Empresa é obrigatória' })}
                  />
                  {errors.company && <p className="text-red-500 text-sm mt-1">{errors.company.message}</p>}
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="email" className="block text-gray-700 font-medium mb-2">E-mail</label>
                  <input
                    type="email"
                    id="email"
                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focoseg-green ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
                    placeholder="seu@email.com"
                    {...register('email', { 
                      required: 'E-mail é obrigatório',
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'E-mail inválido'
                      }
                    })}
                  />
                  {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>}
                </div>
                
                <div>
                  <label htmlFor="phone" className="block text-gray-700 font-medium mb-2">Telefone</label>
                  <input
                    type="tel"
                    id="phone"
                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focoseg-green ${errors.phone ? 'border-red-500' : 'border-gray-300'}`}
                    placeholder="(00) 00000-0000"
                    {...register('phone', { 
                      required: 'Telefone é obrigatório',
                      pattern: {
                        value: /^(\(\d{2}\)\s?)?\d{4,5}-\d{4}$/,
                        message: 'Telefone inválido'
                      }
                    })}
                  />
                  {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone.message}</p>}
                </div>
              </div>
              
              <div className="mb-6">
                <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Mensagem</label>
                <textarea
                  id="message"
                  rows="5"
                  className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focoseg-green ${errors.message ? 'border-red-500' : 'border-gray-300'}`}
                  placeholder="Como podemos ajudar?"
                  {...register('message', { required: 'Mensagem é obrigatória' })}
                ></textarea>
                {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message.message}</p>}
              </div>
              
              <div className="flex justify-center">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-focoseg-green hover:bg-green-600 text-white font-semibold py-3 px-8 rounded-lg transition duration-300 disabled:opacity-50"
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactForm;